/**
 * @description Component-TradeSelectPairMobile
 */
import './index.less';

import DropDownIcon from '@/assets/svg/dropdown.svg?react';
import TokenLogo from '@/components/TokenLogo';
import { useCurrentMarketPairFromUrl } from '@/features/market/hooks';
import { useChainId } from '@/hooks/web3/useChain';
import { FC, useState } from 'react';
import TradingPairsDrawer from './TradingPairsDrawer';

interface IPropTypes {
  onClick?: () => void;
}

const TradeSelectPairMobile: FC<IPropTypes> = ({ onClick }) => {
  const chainId = useChainId();
  const [showPopup, setShowPopup] = useState(false);
  const currentPairBaseInfo = useCurrentMarketPairFromUrl(chainId);

  const handleClick = () => {
    setShowPopup(true);
    onClick?.();
  };

  return (
    <>
      <div className="syn-trade-select-pair-mobile">
        <div className="syn-trade-select-pair-mobile-left" onClick={handleClick}>
          <TokenLogo token={currentPairBaseInfo?.baseToken} size={24} />
          <div className="syn-trade-select-pair-mobile-left-symbol">
            <p>{currentPairBaseInfo?.baseToken?.symbol}</p>
            <p>/</p>
            <p>{currentPairBaseInfo?.quoteToken?.symbol}</p>
          </div>
          <div className="syn-trade-select-pair-mobile-left-arrow">
            <DropDownIcon />
          </div>
        </div>
      </div>

      <TradingPairsDrawer showPopup={showPopup} onClose={() => setShowPopup(false)} />
    </>
  );
};

export default TradeSelectPairMobile;
